var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.cells),function(cell){return _c('td',{key:cell.id},[_c(_vm.getCellComponent(cell),{tag:"component",attrs:{"cell":cell,"column":_vm.getColumn(cell)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }